import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import {
    createRecentlyViewedProduct,
    notifyRecentlyViewedProductsChanged,
    readRecentlyViewedProducts,
    writeRecentlyViewedProducts
} from "../utils/recentlyViewedProducts";


const initialState = {
    isLoading: false,
    isFilterLoading: false,
    isCategoryLoading: false,
    isRefresh: false,
    isProductByIdLoading: false,
    productsByCategoryData: [],
    productsByIdData: {},
    products: [],
    productsBySearchData: {},
    filterOptions: {
        query: ''
    },
    filterOptionsForCategory: {
        categoryId: "",
        subcategory: [],
        priceRange: '',
        sortBy: '',
    },
    subcategoriesByCategoryId: {}, // key: categoryId, value: array of subcategories
    popularProductsData: {},
    filteredProductData: [],
    recentSearchesData: {},
    categoryNamesData: {},
    termsAndConditionData: {},
    maximumAmountOfProductData: {},
    errorMsg: "",
    isError: false
}

export const getAllProductsByCategory = createAsyncThunk('getAllProductsByCategory', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        dispatch(setLoading(true))
        // dispatch(setAllProductsByCategory([]))
        const { data, status } = await api.getAllProductsByCategory(body);
        // dispatch(setClearFilteredProducts())
        if (status === 200) {
            //get categories data           
            dispatch(setAllProductsByCategory(data.data))
            dispatch(setLoading(false))
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const getFilteredProducts = createAsyncThunk(
    'getFilteredProducts',
    async (body, { rejectWithValue, dispatch }) => {
        try {
            // Manually build query string to handle arrays like subcategory
            const queryParams = new URLSearchParams();
            Object.keys(body).forEach((key) => {
              const value = body[key];
              if (Array.isArray(value)) {
                value.forEach((val) => queryParams.append(key, val)); // Append each value
              } else if (value !== undefined && value !== null) {
                queryParams.append(key, value);
              }
            });
            dispatch(setFilterLoading(true));
            const { data, status } = await api.getFilteredProducts(queryParams.toString());            
            if (status === 200) {
                
                dispatch(setFilteredProducts(data.data));
                dispatch(setFilterLoading(false));
                  localStorage.setItem("previousData", JSON.stringify(data.data));
            }
            return data.data;
        } catch (err) {
            dispatch(setFilterLoading(false));
            return rejectWithValue(
                err?.response?.data?.message || "Something went wrong. Please try again later."
            );
        }
    }
);

// actions/categoryActions.js
export const getSubCategoryNames = createAsyncThunk(
    'getSubCategoryNames',
    async (query, { rejectWithValue, dispatch }) => {
        try {
            // const categoryId = new URLSearchParams(query).get("categoryId");
            dispatch(setCategoryLoading(true))
            const { data, status } = await api.getSubCategoryNames(query);
            
            if (status === 200) {
                
                dispatch(setCategoryNames(data.data.data))
                dispatch(setCategoryLoading(false))
            }
            return data.data.data
        } catch (err) {
            dispatch(setCategoryLoading(false))
            return rejectWithValue(err.response?.data?.message || "Something went wrong");
        }
    }
);


export const clearProductsByIdData = createAsyncThunk('clearProductsByIdData', async (body, { rejectWithValue, dispatch }) => {
    try {
        dispatch(setAllProductsById({}))
        dispatch(setProductByIdLoading(false))
    } catch (err) {
        dispatch(setProductByIdLoading(false))
        return rejectWithValue(err.response?.data?.message || "Something went wrong. Please try again later.");
    }
})

export const getAllProductsById = createAsyncThunk(
    "getAllProductsById",
    async (body, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setProductByIdLoading(true))
            const { data, status } = await api.getAllProductsById(body);

            if (status === 200) {
                dispatch(setAllProductsById(data.data));
                dispatch(setProductByIdLoading(false))
                const newProduct = createRecentlyViewedProduct(data.data);

                if (!newProduct) {
                    console.error("Product data is missing");
                    return data.data;
                }

                let viewedProducts = readRecentlyViewedProducts();

                // Remove duplicate if it already exists
                viewedProducts = viewedProducts.filter(product => product.id !== newProduct.id);

                // Add the new product at the beginning
                viewedProducts.unshift(newProduct);

                // Keep only the latest 10 products
                viewedProducts = viewedProducts.slice(0, 10);

                // Save updated list back to localStorage
                if (writeRecentlyViewedProducts(viewedProducts)) {
                    notifyRecentlyViewedProductsChanged(viewedProducts);
                }

                // console.log("Updated Recently Viewed:", JSON.parse(localStorage.getItem("recentlyViewed")));
            }
            return data.data;
        } catch (err) {
            dispatch(setProductByIdLoading(false))
            return rejectWithValue(err.response?.data?.message || "Something went wrong. Please try again later.");
        }
    }
);

export const increamentProductCount = createAsyncThunk('increamentProductCount', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.increamentProductCount(body);
        if (status === 200) {
            //get categories data
            dispatch(setIncreamentProductCount(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const getProductsBySearch = createAsyncThunk(
    "getProductsBySearch",
    async (body, { rejectWithValue, dispatch }) => {
        try {
            const queryParams = new URLSearchParams(body).toString();
            const { data, status } = await api.getProductsBySearch(queryParams);

            if (status === 200) {
                const searchKey = body.query.trim(); // Ensure it's a full word

                if (searchKey && searchKey.length > 1) { // Ignore single letters
                    let recentSearches = JSON.parse(localStorage.getItem("recentSearches")) || [];

                    // Prevent duplicates and add the latest search
                    recentSearches = recentSearches.filter((item) => item !== searchKey);
                    recentSearches.unshift(searchKey);

                    // Store only full words, not partial inputs
                    localStorage.setItem("recentSearches", JSON.stringify(recentSearches));

                    // Update Redux with recent searches (limit to last 3)
                    dispatch(setRecentSearches(recentSearches.slice(0, 3)));
                }

                dispatch(setProductsBySearch(data));
            }
            return data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Something went wrong. Please try again later."
            );
        }
    }
);
export const getPopularProduct = createAsyncThunk('getPopularProduct', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getPopularProduct();
        if (status === 200) {
            //get categories data
            dispatch(setPopularProduct(data.data.data))
        }
        return data.data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const getTermsAndCondition = createAsyncThunk('getTermsCondition', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getTermsCondition();
        if (status === 200) {
            //get categories data
            dispatch(setTermsAndCondition(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const getMaximumAmountOfProduct = createAsyncThunk('getMaximumAmountOfProduct', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getMaximumAmountOfProduct();
        if (status === 200) {
            //get categories data
            dispatch(setMaximumAmountOfProduct(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const resetFilters = () => ({
    type: 'RESET_FILTERS',
  });

export const productsSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setFilterLoading: (state, action) => {
            state.isFilterLoading = action.payload
        },
        setCategoryLoading: (state, action) => {
            state.isCategoryLoading = action.payload
        },
        setAllProductsByCategory: (state, action) => {
            state.productsByCategoryData = action.payload
        },
        setFilteredProducts: (state, action) => {
            state.filteredProductData = action.payload
        },
        // setClearFilteredProducts: (state) => {
        //     state.productsByCategoryData = [];
        // },
        setAllProductsById: (state, action) => {
            state.productsByIdData = action.payload
        },
        setProductsBySearch: (state, action) => {
            state.productsBySearchData = action.payload
        },
        setRecentSearches: (state, action) => {
            state.recentSearchesData = action.payload
        },
        setPopularProduct: (state, action) => {
            state.popularProductsData = action.payload
        },
        setCategoryNames: (state, action) => {
            state.categoryNamesData = action.payload
        },
        setTermsAndCondition: (state, action) => {
            state.termsAndConditionData = action.payload
        },
        setMaximumAmountOfProduct: (state, action) => {
            state.maximumAmountOfProductData = action.payload
        },
        setRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        },
        setFilterValues: (state, action) => {
            state.filterOptions = { ...state.filterOptions, ...action.payload }
        },
        setFilterValuesCate: (state, action) => {
            state.filterOptionsForCategory = { ...state.filterOptionsForCategory, ...action.payload }
        },
        setProductByIdLoading: (state, action) => {
            state.isProductByIdLoading = action.payload
        },
        resetFilterOptionsForCategory: (state) => {
            state.filterOptionsForCategory = {
            //   categoryId: "",
              subcategory: [],
              priceRange: '',
              sortBy: '',
            };
            state.filteredProductData = [];
          },

    },
    extraReducers: (builder) => {

        // getFilteredProducts
        // builder.addCase(getFilteredProducts.pending, (state) => {
        //     state.isLoading = true
        //     state.errorMsg = null
        // })
        // builder.addCase(getFilteredProducts.fulfilled, (state, action) => {
        //     state.isLoading = false
        //     state.filteredProductData = action.payload
        // })
        // builder.addCase(getFilteredProducts.rejected, (state, action) => {
        //     state.isLoading = false
        //     state.errorMsg = action.payload
        // })

        // setAllProducts
        // builder.addCase(getAllProductsByCategory.pending, (state) => {
        //     state.isLoading = true
        //     state.isError = false
        // })
        // builder.addCase(getAllProductsByCategory.fulfilled, (state, action) => {
        //     state.isLoading = false
        //     state.productsByCategoryData = action.payload
        // })
        // builder.addCase(getAllProductsByCategory.rejected, (state, action) => {
        //     state.isLoading = false
        //     state.errorMsg = action.payload
        // })
        // getAllProductsById
        builder.addCase(getAllProductsById.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getAllProductsById.fulfilled, (state, action) => {
            state.isLoading = false
            state.productsByIdData = action.payload
        })
        builder.addCase(getAllProductsById.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
        // getProductsBySearch
        builder.addCase(getProductsBySearch.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getProductsBySearch.fulfilled, (state, action) => {
            state.isLoading = false
            state.productsBySearchData = action.payload
        })
        builder.addCase(getProductsBySearch.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
        // builder
        //     .addCase(getSubCategoryNames.pending, (state) => {
        //         state.isLoading = true;
        //         state.errorMsg = null;
        //     })
        //     .addCase(getSubCategoryNames.fulfilled, (state, action) => {
        //         state.isLoading = false;
        //         state.categoryNamesData = action.payload;
        //     })
        //     .addCase(getSubCategoryNames.rejected, (state, action) => {
        //         state.isLoading = false;
        //         state.errorMsg = action.payload;
        //     });
    }
})

export const {
    setLoading,
    setFilterLoading,
    setCategoryLoading,
    setRefresh,
    setAllProductsByCategory,
    setAllProductsById,
    setProductsBySearch,
    setFilterValues,
    setPopularProduct,
    setIncreamentProductCount,
    setRecentSearches,
    setCategoryNames,
    setFilterValuesCate,
    setFilteredProducts,
    setClearFilteredProducts,
    setTermsAndCondition,
    setMaximumAmountOfProduct,
    resetFilterOptionsForCategory,
    setProductByIdLoading
} = productsSlice.actions

export default productsSlice.reducer;
